import { JobsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { TCall } from 'app/queries/types/TCall';
import type { jobsKeys } from './jobsKeys';

type TParams = QueryFunctionContext<ReturnType<typeof jobsKeys.assigneeHistory>>;

export const createFetchJobAssigneeHistoryQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ jobId, workspaceId }], signal }: TParams) =>
    call(() => cancelOnSignal(JobsService.getJobAssigneeHistory({ wsid: workspaceId, jobId }), signal));
